import { SUPPORTED_UNITS } from '@/helpers/unit-formatter/unit-formatter.constants';

const DEFAULT_PRECISION = 2;

/**
 * Unit-level precision overrides for formatter defaults.
 * These are centralized so we can later merge/replace with backend-provided precision.
 */
const UNIT_PRECISION_OVERRIDES: Record<string, number> = {
  [SUPPORTED_UNITS.CFM]: 2,
  [SUPPORTED_UNITS.FT]: 1,
  [SUPPORTED_UNITS.GPM]: 2,
  [SUPPORTED_UNITS.PSID]: 2,
  [SUPPORTED_UNITS.HRS]: 2,
  [SUPPORTED_UNITS.MIN]: 0,
  [SUPPORTED_UNITS.SEC]: 0,
};

export interface ResolveUnitPrecisionArgs {
  units?: string;
  fallbackPrecision?: number;
  explicitPrecision?: number;
}

export const resolveUnitPrecision = ({
  units,
  fallbackPrecision = DEFAULT_PRECISION,
  explicitPrecision,
}: ResolveUnitPrecisionArgs): number => {
  if (typeof explicitPrecision === 'number' && Number.isFinite(explicitPrecision)) {
    return explicitPrecision;
  }

  const unitKey = units?.toLowerCase();
  if (!unitKey) {
    return fallbackPrecision;
  }

  return UNIT_PRECISION_OVERRIDES[unitKey] ?? fallbackPrecision;
};
